// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class SimpleSlider extends Vue {
  @Prop({ default: "" })
  label?: string;

  @Prop({ default: [] })
  values!: Array<number>;

  @Prop({ default: false })
  disabled?: boolean;

  @Prop()
  value?: number;

  slider;

  slidePositions: number[] = [];
  leftPosition = 0;
  isMoving = false;
  portionHalf = 0;

  leftOffset = 0;
  leftIndex = 0;

  created() {
    window.addEventListener("resize", this.handleResize);
  }

  mounted() {
    this.slider = <HTMLElement>this.$refs["sliderarea"];
    this.init();
  }

  @Watch("values")
  private init() {
    this.slidePositions = [];
    this.leftPosition = 0;
    this.portionHalf = 0;

    this.leftOffset = 0;
    this.leftIndex = 0;

    let slidearea = this.slider.getBoundingClientRect().width;
    this.leftPosition = this.slider.getBoundingClientRect().left;

    if (this.values.length > 1) {
      for (let i = 0; i < this.values.length; i++) {
        let positionValue = i * (slidearea / (this.values.length - 1));
        this.slidePositions.push(Math.floor(positionValue));
      }
      this.portionHalf = this.slidePositions[1] / 2;
    }
    this.slidePositions[this.slidePositions.length - 1] =
      this.slidePositions[this.slidePositions.length - 1] - 15;
    this.onValueChange();
  }

  @Watch("disabled")
  private onDisable() {
    this.leftOffset = 0;
    this.leftIndex = 0;
    this.returnValue();
  }

  @Watch("value")
  private onValueChange() {
    if (this.value) {
      let index = this.values.findIndex((v) => v == this.value);
      this.leftIndex = index;
      this.leftOffset = this.slidePositions[index];
    }
  }

  get valuesLength() {
    return this.values.length;
  }

  get trackStyle() {
    return "left: 0px;  right: calc(100% - " + this.leftOffset + "px);";
  }

  private handleResize() {
    let slidearea = this.slider.getBoundingClientRect().width;
    this.leftPosition = this.slider.getBoundingClientRect().left;

    this.slidePositions = [];

    if (this.values.length > 1) {
      for (let i = 0; i < this.values.length; i++) {
        let positionValue = i * (slidearea / (this.values.length - 1));
        this.slidePositions.push(Math.floor(positionValue));
      }
      this.portionHalf = this.slidePositions[1] / 2;
    }
    this.slidePositions[this.slidePositions.length - 1] =
      this.slidePositions[this.slidePositions.length - 1] - 15;
    this.leftOffset = this.slidePositions[this.leftIndex];
  }

  public mousedown($event) {
    $event.preventDefault();
    if (!this.disabled) {
      this.isMoving = true;
      window.addEventListener("mousemove", this.thumbMove);
      window.addEventListener("mouseup", this.mouseup);
    }
  }

  private mouseup() {
    this.isMoving = false;
    window.removeEventListener("mousemove", this.thumbMove);
    window.removeEventListener("mouseup", this.mouseup);
  }

  private thumbMove($event) {
    if ($event.clientX < this.leftPosition + this.portionHalf) {
      this.leftOffset = this.slidePositions[0];
      this.leftIndex = 0;
      this.returnValue();
    } else if (
      $event.clientX >
      this.leftPosition +
        this.portionHalf * (2 * this.slidePositions.length - 3)
    ) {
      this.leftOffset = this.slidePositions[this.slidePositions.length - 1];
      this.leftIndex = this.slidePositions.length - 1;
      this.returnValue();
    } else {
      for (let i = 1; i < this.slidePositions.length - 1; i++) {
        if (
          $event.clientX > this.leftPosition + this.portionHalf * (2 * i - 1) &&
          $event.clientX < this.leftPosition + this.portionHalf * (2 * i + 1)
        ) {
          this.leftOffset = this.slidePositions[i];
          this.leftIndex = i;
          this.returnValue();
        }
      }
    }
  }

  public returnValue() {
    this.$emit("valueChange", this.values[this.leftIndex]);
  }
}
